import request from '../request'

/**
 * 设计成果校审相关接口
 */

/**
 * 新增设计成果
 * @param {Object} data - 设计成果数据
 */
export function addDesignResult(data) {
    return request({
        url: '/project-service/cosys/design/result/add',
        method: 'POST',
        data
    })
}

/**
 * 获取校审记录详情
 * @param {string|number} id - 校审记录ID
 */
export function fetchDesignResultAuditDetail(id) {
    return request({
        url: `/project-service/cosys/design/result/audit/detail/${id}`,
        method: 'GET'
    })
}

/**
 * 获取校审记录列表
 * @param {Object} params - 查询参数（分页、筛选等）
 */
export function fetchDesignResultAuditList(params) {
    return request({
        url: '/project-service/cosys/design/result/audit/list',
        method: 'GET',
        params
    })
}

/**
 * 批量新增校审批注
 * @param {Object} data - 批注数据列表
 */
export function addDesignResultAuditMarkupComment(data) {
    return request({
        url: '/project-service/cosys/design/result/audit/markup/comment/add',
        method: 'POST',
        data
    })
}

/**
 * 批量回复校审批注
 * @param {Object} data - 回复数据列表
 */
export function replyDesignResultAuditMarkupComment(data) {
    return request({
        url: '/project-service/cosys/design/result/audit/markup/comment/reply',
        method: 'POST',
        data
    })
}

/**
 * 获取文件每页的地址和校审批注列表
 * @param {string|number} fileId - 文件ID
 * @param {string|number} pageId - 页码/页面ID
 */
export function fetchDesignResultAuditMarkupComments(fileId, pageId) {
    return request({
        url: `/project-service/cosys/design/result/audit/markup/comments`,
        method: 'GET',
        params: { fileId, pageId }
    })
}

/**
 * 获取校审批注文件版本列表
 * @param {string|number} auditId - 校审记录ID
 */
export function fetchDesignResultAuditMarkupFiles(auditId) {
    return request({
        url: `/project-service/cosys/design/result/audit/markup/files/${auditId}`,
        method: 'GET'
    })
}

/**
 * 根据版本号查询校审批注文件列表
 * @param {string|number} auditId - 校审记录ID
 * @param {string|number} versionNo - 版本号
 */
export function fetchDesignResultAuditMarkupFilesByVersion(auditId, versionNo) {
    return request({
        url: `/project-service/cosys/design/result/audit/markup/files/${auditId}/version/${versionNo}`,
        method: 'GET'
    })
}

/**
 * 校审批注上传新版本附件并拆分PDF
 * @param {Object} data - 上传数据（FormData 格式）
 */
export function uploadDesignResultAuditMarkup(data) {
    return request({
        url: '/project-service/cosys/design/result/audit/markup/upload',
        method: 'POST',
        data
    })
}

/**
 * 手动导出校审报告（测试）
 * @param {string|number} auditId - 校审记录ID
 */
export function exportDesignResultAuditReport(auditId) {
    return request({
        url: `/project-service/cosys/design/result/audit/report/export/${auditId}`,
        method: 'POST',
        responseType: 'blob'
    })
}

/**
 * 删除设计成果
 * @param {string|number} id - 设计成果ID
 */
export function deleteDesignResult(id) {
    return request({
        url: `/project-service/cosys/design/result/del/${id}`,
        method: 'GET'
    })
}

/**
 * 获取设计成果详情
 * @param {string|number} id - 设计成果ID
 */
export function fetchDesignResultDetail(id) {
    return request({
        url: `/project-service/cosys/design/result/detail/${id}`,
        method: 'GET'
    })
}

/**
 * 获取设计成果列表
 * @param {Object} params - 查询参数（分页、筛选等）
 */
export function fetchDesignResultList(params) {
    return request({
        url: '/project-service/cosys/design/result/list',
        method: 'GET',
        params
    })
}

/**
 * 重新发起校审审批（仅Cancel/Reject状态可操作）
 * @param {Object} data - 审批参数（通常含id、状态等）
 */
export function resubmitDesignResult(data) {
    return request({
        url: '/project-service/cosys/design/result/resubmit',
        method: 'POST',
        data
    })
}

/**
 * 送校审
 * @param {Object} data - 送审参数（通常含id等）
 */
export function sendDesignResultToAudit(data) {
    return request({
        url: '/project-service/cosys/design/result/sendToAudit',
        method: 'POST',
        data
    })
}
/**
 * 编辑设计成果
 * @param {Object} data - 送审参数
 */
export function updateResult(data) {
    return request({
        url: '/project-service/cosys/design/result/update',
        method: 'POST',
        data
    })
}


/**
 * 获取auditNo
 * @param {Object} params
 */
export function fetchGenerateAuditNo(phaseId, wbsFullId) {
    return request({
        url: `/project-service/cosys/design/result/generateAuditNo/${phaseId}/${wbsFullId}`,
        method: 'GET'
    })
}

/**
 * 获取阶段任务概要
 * @param {string|number} phaseId - 阶段任务ID
 */
export function fetchPrjTaskPhaseSummary(phaseId) {
    return request({
        url: `/project-service/cosys/prj/task/phase/summary/${phaseId}`,
        method: 'GET'
    })
}

/**
 * 根据auditId获取文件批注统计信息
 * @param {string} auditId - 审核ID
 */
export function getDesignResultAuditMarkupStatistics(auditId) {
    return request({
        url: `/project-service/cosys/design/result/audit/markup/statistics/${auditId}`,
        method: 'GET'
    })
}

/**
 * 获取pdf
 */
export function queryFileById(id) {
    return request({
        url: `/common-service/file/query/${id}`,
        method: 'GET',
    })
}



//替换签章文件
export function replaceFile(data) {
    return request({
        url: '/project-service/cosys/design/stamp/replaceFile',
        method: 'POST',
        data
    })
}


/**
 * 替换设计成果
 * @param {Object} data - 设计成果数据
 */
export function addReplace(data) {
    return request({
        url: '/project-service/cosys/replace/add',
        method: 'POST',
        data
    })
}

/**
 * 获取替换成果详情
 * @param {string|number} id - 设计成果ID
 */
export function fetchReplaceDetail(id) {
    return request({
        url: `/project-service/cosys/replace/detail/${id}`,
        method: 'GET'
    })
}



/**
 * 重新发起替换成果（仅Cancel/Reject状态可操作）
 * @param {Object} data - 审批参数（通常含id、状态等）
 */
export function resubmitReplaceResult(data) {
    return request({
        url: '/project-service/cosys/replace/resubmit',
        method: 'POST',
        data
    })
}

/**
 * 获取校审意见列表
 * @param {string|number} id - 校审记录ID
 * @param {string} step - 校审阶段（如design_approver）
 */
export function fetchDesignResultAuditOpinions(id, step) {
    return request({
        url: `/project-service/cosys/design/result/audit/opinions/${id}`,
        method: 'GET',
        params: { step }
    })
}